import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import DontLeave from "app/pages/.shared/DontLeave";
import "./TechnicalErrorDefault.scss";
import AlertMessage from "app/pages/.shared/AlertMessage";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const TechnicalErrorDefault = ({ brandDisplayName, errorMessage, fallbackRedirectUrl }) => {
	return (
		<div className="technical-error">
			<div className="technical-error__intro">
				{errorMessage && <AlertMessage message={errorMessage} />}

				<FormattedMessage
					id="technical.error.default.message"
					values={{ brandName: brandDisplayName }}
				/>

				<DontLeave>
					<Button
						to={{ pathname: fallbackRedirectUrl }}
						variant={BUTTON_VARIANTS.FILLED}
						size={BUTTON_SIZES.LARGE}
						label={<FormattedMessage id="confirmation.leave.button.label" />}
						data-testid={"go-to-fallback-url-button"}
					/>
				</DontLeave>
			</div>
		</div>
	);
};

TechnicalErrorDefault.propTypes = {
	brandDisplayName: PropTypes.string,
	errorMessage: PropTypes.string,
	fallbackRedirectUrl: PropTypes.string,
};

export default TechnicalErrorDefault;
